import Box from '@mui/material/Box';
import { colours } from '../theme';

/**
 * A small pill, e.g. a role. Barlow Medium 13 px on pale grey; "strong" is near black,
 * "mint" is charge mint with near-black text.
 */
export function Tag({ children, strong, mint }: { children: React.ReactNode; strong?: boolean; mint?: boolean }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 1.25,
        py: 0.25,
        borderRadius: 999,
        fontSize: 13,
        lineHeight: '20px',
        fontWeight: 500,
        bgcolor: strong ? colours.nearBlack : mint ? colours.chargeMint : colours.paleGrey,
        color: strong ? colours.white : mint ? colours.nearBlack : colours.graphite,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </Box>
  );
}
